/**
 * Updates (audit trail) API.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';
import type { ProjectUpdate } from '../types/dvms.types';

export async function listUpdates(): Promise<ProjectUpdate[]> {
    const resp = await apiFetch<{ data: ProjectUpdate[] | null | undefined }>(API.PROJECT_UPDATES);
    return resp.data ?? [];
}

export async function createUpdate(payload: ProjectUpdate): Promise<ProjectUpdate> {
    return apiFetch<ProjectUpdate>(API.PROJECT_UPDATES, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}
